const numberFormat = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' })
export const displayPrice = (price: number | string) => {
  const number = typeof price === 'string' ? Number(price) : price
  return numberFormat.format(number)
}

export const toStringNumber = (number: number) => `${Number(number.toFixed(2))}`

export const toPhoneString = (phone: string) => {
  return phone?.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')
}